module.exports = "/fonts/vendor/element-ui/lib/theme-chalk/element-icons.woff?535877f50039c0cb49a6196a5b7517cd";


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = MtQs
// module chunks = 182